import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./app/store";
import { ThemeModeProvider } from "./features/theme/ThemeModeContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <ThemeModeProvider>
      <App />
    </ThemeModeProvider>
  </Provider>
);
